<mat-form-field
  class="dates-select px-0 mt-0 w-100"
  appearance="outline"
  (click)="picker.open()"
  onkeypress="picker.open()"
>
  <mat-label>Seleccione fechas</mat-label>
  <mat-date-range-input
    [formGroup]="dateForm"
    [rangePicker]="picker"
    class="pt-1"
  >
    <input
      matStartDate
      placeholder="Fecha inicial"
      formControlName="fromDate"
    />
    <input
      matEndDate
      placeholder="Fecha final"
      formControlName="toDate"
      (dateChange)="applyFn()"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker #picker (closed)="onCalendarClosed()"></mat-date-range-picker>
</mat-form-field>
